import constants from 'scoreboard/components/constants'
const { NUMBER, STABILIZE_NUMBER, SCORED_TEXT, UNSCORED_TEXT } = constants
import config from 'scoreboard/components/config'

function defaultColors(kpiValueType,
		allowScoresBelowMin = config.allowScoresBelowMin,
		allowScoresAboveMax = config.allowScoresAboveMax) {
	if (kpiValueType == UNSCORED_TEXT) {
		return []
	}

	let colors = ['red-medium', 'green-medium']
	if (kpiValueType == STABILIZE_NUMBER) {
		colors = ['red-medium', 'green-medium', 'green-medium', 'red-medium']
	}

	// #48821 for scored text there are a number of colors equal to the
	// number of thresholds, so we're not adding extra "love handle" colors on
	// the ends
	if (kpiValueType != SCORED_TEXT) {
		if (allowScoresBelowMin) {
			colors = [colors[0]].concat(colors)
		}
		if (allowScoresAboveMax) {
			colors = colors.concat(colors[colors.length - 1])
		}
	}

	return colors
}

export default defaultColors

defaultColors.__filename__ = 'admin/scoring-types/default-colors.js'
